import {
  LayoutAnimation,
  LayoutAnimationProperty,
  UIManager,
} from 'react-native';

import platformConfig from '/config/platform.config';

export const enableLayoutAnimation = () => {
  const OS = platformConfig.getOS();

  if (OS === 'android' && UIManager.setLayoutAnimationEnabledExperimental) {
    UIManager.setLayoutAnimationEnabledExperimental(true);
  }
};

export const safeEaseInEaseOut = {
  duration: 400,
  create: {
    type: LayoutAnimation.Types.easeInEaseOut,
    property: 'opacity' as LayoutAnimationProperty,
  },
  update: {
    type: LayoutAnimation.Types.easeInEaseOut,
    property: 'opacity' as LayoutAnimationProperty,
  },
};

export const safeLayoutAnimation = () => {
  LayoutAnimation.configureNext(safeEaseInEaseOut);
};
